import "./profile.scss";
import { useState } from "react";
import axiosInstance from "../../services/api";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../services/authService";
import { useSnackbar } from "../../context/SnackbarContext";
import CircularProgressBox from "../../components/CircularProgressBox";

const Profile = () => {
  const [passwordInfo, setPasswordInfo] = useState({
    oldPassword: "",
    newPassword: "",
  });
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [succeed, setSucceed] = useState(false);

  const { showSnackbar } = useSnackbar();

  const dispatch = useDispatch();

  const validatePassword = (password) => {
    // At least 6 characters, one uppercase, one lowercase, one number, one special character
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*?&])[A-Za-z\d@#$!%*?&]{6,}$/;
    return regex.test(password);
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;

    setPasswordInfo((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validatePassword(passwordInfo.newPassword)) {
      showSnackbar(
        "Password must be at least 6 characters long and include one uppercase, one lowercase, number, and special character.",
        "warning",
      );
      return;
    }

    if (passwordInfo.oldPassword === passwordInfo.newPassword) {
      showSnackbar("Both passwords are same. Choose different one.", "warning");
      return;
    }

    if (passwordInfo.newPassword !== confirmPassword) {
      showSnackbar("Confirm password mismatch.", "warning");
      return;
    }

    setLoading(true);

    // If validation passes, proceed with API call or logic
    try {
      await axiosInstance.put("/users/me", passwordInfo);
      showSnackbar(
        "Your password has been changed. Redirecting to login page...",
        "success",
      );
      setSucceed(true);
      // redirect after a short delay
      setTimeout(() => {
        logoutUser(dispatch);
      }, 2000);
    } catch (err) {
      if (err.response?.status === 400) {
        showSnackbar(
          "Old password is incorrect. Enter the correct password.",
          "warning",
        );
      } else {
        showSnackbar(
          err.response?.data?.message || "Unable to change password.",
          "error",
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form className="profileForm" onSubmit={handleSubmit}>
        <div className="formInput">
          <label htmlFor="oldPassword">Old Password</label>
          <input
            id="oldPassword"
            name="oldPassword"
            type="password"
            //   value={passwordInfo.oldPassword}
            onChange={handlePasswordChange}
            required
          />
        </div>

        <div className="formInput">
          <label htmlFor="newPassword">New Password</label>
          <input
            id="newPassword"
            name="newPassword"
            type="password"
            //   value={passwordInfo.newPassword}
            onChange={handlePasswordChange}
            required
          />
        </div>

        <div className="formInput">
          <label htmlFor="confirmPassword">Confirm Password</label>
          <input
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            //   value={passwordInfo.confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        <button disabled={loading || succeed} type="submit">Change</button>
      </form>
      <div className="passwordRequirements">
        <div className="requirementsHeader">
          <span className="requirementsIcon">🔐</span>
          <h3>Password Requirements</h3>
        </div>
        <ul className="requirementsList">
          <li className={passwordInfo.newPassword.length >= 6 ? "met" : ""}>
            <span className="checkmark">✓</span>
            <span className="text">6 characters minimum</span>
          </li>
          <li className={/[A-Z]/.test(passwordInfo.newPassword) ? "met" : ""}>
            <span className="checkmark">✓</span>
            <span className="text">One uppercase letter</span>
          </li>
          <li className={/[a-z]/.test(passwordInfo.newPassword) ? "met" : ""}>
            <span className="checkmark">✓</span>
            <span className="text">One lowercase letter</span>
          </li>
          <li className={/\d/.test(passwordInfo.newPassword) ? "met" : ""}>
            <span className="checkmark">✓</span>
            <span className="text">One number</span>
          </li>
          <li
            className={/[@#$!%*?&]/.test(passwordInfo.newPassword) ? "met" : ""}
          >
            <span className="checkmark">✓</span>
            <span className="text">One special character (@#$!%*?&)</span>
          </li>
        </ul>
      </div>
      {loading && <CircularProgressBox />}
    </>
  );
};

export default Profile;
